var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0C9.69561 0 0.5 8.97133 0.5 20C0.5 31.0287 9.69561 40 21 40C32.3044 40 41.5 31.0271 41.5 20C41.5 8.97289 32.3044 0 21 0ZM21 36.9016C11.4487 36.9016 3.67582 29.3199 3.67582 20C3.67582 10.6801 11.4487 3.09836 21 3.09836C30.5529 3.09836 38.3242 10.6801 38.3242 20C38.3242 29.3199 30.5513 36.9016 21 36.9016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4053 13.0441C29.759 12.4709 28.7538 12.5158 28.1632 13.1494L18.4768 23.5554L13.7972 18.914C13.1795 18.3036 12.176 18.2943 11.5519 18.8954C10.9263 19.495 10.9167 20.4756 11.5329 21.086L17.3907 26.8954C17.6908 27.1929 18.0973 27.3586 18.5228 27.3586C18.5323 27.3586 18.5435 27.3586 18.553 27.3602C18.9913 27.3509 19.4041 27.1681 19.6979 26.8521L30.5131 15.2332C31.1024 14.5979 31.0547 13.6189 30.4053 13.0441Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound);
export default __webpack_public_path__ + "static/media/check-round.99beae1fb01e3943c4ecfdc43a1ef291.svg";
export { ForwardRef as ReactComponent };